import "./HomePage.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { homepage_header, page_logo } from "../../Imgs/images";
// import { useEffect, useState } from "react";

import Partners from "./Partners/Partners";
import Services from "./Services/Services";
import Enterprise from "./Enterprise/Enterprise";
import OurValues from "./OurValues/OurValues";

function HomePage() {
  // const [articles, setArticles] = useState([]);

  // useEffect(() => {
  //   fetch(`${process.env.REACT_APP_DOMAIN}api/news/actualites.json`)
  //     .then((response) => response.json())
  //     .then((response) => setArticles(response))
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, []);

  return (
    <>
      <Header />
      <section className="hp-header">
        <picture className="hp-header-background">
          <source srcSet={homepage_header} />
          <img src={homepage_header} alt="personnes sur un chantier" />
        </picture>
        <div className="hp-header-content">
          <picture className="hp-header-logo">
            <source srcSet={page_logo} />
            <img src={page_logo} alt="logo SPenseignement" />
          </picture>
          <h1 className="hp-header-content-title">
            Préparez vous à sauver des vies !
          </h1>
        </div>
      </section>
      <Partners />
      <OurValues />
      <Services />
      <Enterprise />
      <Footer />
    </>
  );
}
export default HomePage;
